import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-[72px] px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-movie-2-fill text-lg"></i>
          </span>
          <span className={`font-heading text-lg font-semibold ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
            樱桃视频
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`px-3 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#address"
            className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-links-line"></i>
            获取最新地址
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-9 h-9 rounded-md flex items-center justify-center cursor-pointer ${
              scrolled ? "text-foreground-900 bg-background-100" : "text-background-50 bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-3">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-2 py-3 text-sm text-foreground-800 border-b border-background-200/60 last:border-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}